import { useCallback } from 'react';

interface UsePasteHandlerProps {
  onFileSelect: (file: File) => void;
}

export const usePasteHandler = ({ onFileSelect }: UsePasteHandlerProps) => {
  const handlePaste = useCallback((event: ClipboardEvent) => {
    const items = event.clipboardData?.items;
    if (!items) return;

    for (const item of items) {
      if (item.type.startsWith('image/')) {
        const file = item.getAsFile();
        if (file) {
          onFileSelect(file);
        }
      }
    }
  }, [onFileSelect]);

  return { handlePaste };

}; 